// Printed Collection Sheet index (the page before the societies): sizing so it stays ONE page.
//
// The index rows use screen padding, so with ~40+ societies (a projected month lists every regular
// customer's society — 49 in Sep 2026) it spilled onto a second printed page. This picks, from the
// society count alone, the LARGEST row height that still fits the page and hands it to the print CSS
// as variables — so a short list prints exactly as before and a long one is tightened only as much as
// it has to be, never more. Numbers mirror the page's print CSS: A4 portrait, 8 mm top / 10 mm bottom
// margin, and the letterhead above the table (20 mm top margin + 24 pt heading).
const PAGE_MM = 297 - 8 - 10;
const LETTERHEAD_MM = 36;
const SAFETY_MM = 3; // printers and browsers differ by a millimetre or two
export const INDEX_ROOM_MM = PAGE_MM - LETTERHEAD_MM - SAFETY_MM;
// Measured in headless Chrome's print layout (not estimated): a data row is 8.71 mm (6px + 6px padding,
// 0.83rem text at 1.6 line height, 1px border) and the header row 9.64 mm, so 26 societies fit as-is and
// 27 spill onto a second page.
export const NATURAL_ROW_MM = 8.71;
export const NATURAL_HEADER_MM = 9.64;
const HEADER_EXTRA_MM = 0.8; // once tightened, the header row is a data row plus its extra padding (2 x 0.4 mm)
const PT_MM = 25.4 / 72;
const LINE_HEIGHT = 1.25;
const BORDER_MM = 0.3;

const round = (n, places = 2) => Number(n.toFixed(places));

// Row height (mm) that makes `count` rows plus the header fit, or null when the natural heights already do.
export function indexRowMm(count) {
  const n = Math.max(count, 0);
  if (NATURAL_HEADER_MM + n * NATURAL_ROW_MM <= INDEX_ROOM_MM) return null;
  return (INDEX_ROOM_MM - HEADER_EXTRA_MM) / (n + 1);
}

// CSS variables for the index card, or {} when nothing needs changing (the print CSS falls back to the
// screen values). Font steps down only when the row is too short for the bigger size to breathe.
export function indexPrintVars(count) {
  const rowMm = indexRowMm(count);
  if (rowMm == null) return {};
  const fontPt = rowMm >= 6.2 ? 9.5 : rowMm >= 5.4 ? 9 : rowMm >= 4.6 ? 8 : rowMm >= 4.1 ? 7 : 6.5;
  const lineMm = fontPt * PT_MM * LINE_HEIGHT;
  const padMm = Math.max(0.3, (rowMm - lineMm - BORDER_MM) / 2);
  return {
    '--cs-index-font': `${fontPt}pt`,
    '--cs-index-lh': String(LINE_HEIGHT),
    '--cs-index-pad': `${round(padMm)}mm`,
    '--cs-index-pad-th': `${round(padMm + 0.4)}mm`, // the header row keeps a touch more air
  };
}
